// extracted by mini-css-extract-plugin
export default {"image":"CarouselPhoto_image__f9Ou8"};